import React from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { selectAffixes } from '../../store/data.selectors';
import Affix from './Affix';
import styles from './Affixes.css';

const Affixes = () => {
  const { prefixes, suffixes } = useAppSelector(selectAffixes);
  const { affixType } = useParams();
  const affixes = affixType === 'prefixes' ? prefixes : suffixes;

  return (
    <div className={styles.wrapper}>
      {affixes.map((affix) => (
        <Affix affix={affix} key={affix.tag} />
      ))}
    </div>
  );
};

export default Affixes;